import Swiper from "swiper";
import { Navigation, Pagination, Autoplay , EffectFade } from "swiper/modules";
import { variables } from "./_variables.js";
import init from "./_scrollIn.js";

const { isMobile , isUserAgentMobile } = variables();
// otherSwiper関数の定義
export const infiniteSwiper = () => {
  const el = document.querySelector(".infinite-slider");
  const options = {
    modules: [Autoplay],
    loop: true,
    slidesPerView: 2,
    speed: 8000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 5,
      },
    },
  };
  // 要素が存在しない場合は何もしない
  if (!el) return;
  // Swiperインスタンスを生成して返す
  console.log(el);
  return new Swiper(el, options);
};


export const postGallerySwiper = () => {
  const el = document.querySelector(".post-gallery-swiper");
  if (!el) return;
  const options = {
    modules: [Autoplay, EffectFade],

    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    slidesPerView: 1,
    speed: 1000,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
  };
  return new Swiper(el, options); 
};


export const mainVisualSwiper = () => {
  const el = document.querySelector(".main-visual-swiper");
  console.log(el);
  // 要素が存在しない場合は何もしない
  if (!el) return;
  const options = {
    modules: [Autoplay, EffectFade],
    effect: 'fade',
    loop: true,
    slidesPerView: 1,
    speed: 1000,
    allowTouchMove: false,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    fadeEffect: {
      crossFade: true,
    },
    on: {
      init: function() {
        const activeSlide = this.slides[this.activeIndex];
        const activeImg = activeSlide.querySelector('img');
        if (activeImg) {
          activeImg.style.transition = 'transform 6s linear';
          activeImg.style.transform = 'scale(1.1)';
        }
      },
      slideChangeTransitionStart: function() {
        document.querySelectorAll('.main-visual-swiper .swiper-slide img').forEach(img => {
          img.style.transform = 'scale(1)';
        });
      },
      slideChangeTransitionEnd: function() {
        const activeSlide = this.slides[this.activeIndex];
        const activeImg = activeSlide.querySelectorAll('img');
        if (activeImg) {
          activeImg.forEach(img => {
            img.style.transition = 'transform 6s linear';
            img.style.transform = 'scale(1.1)';
          });
        }
      }
    }
  };
  
  
  // Swiperインスタンスを生成して返す
  return new Swiper(el, options);
};


export const interviewSwiper = () => {
  // interview-swiper要素を取得
  const el = document.querySelector(".js-interview-swiper");
  const itemLength = el?.querySelectorAll('.interview-swiper .swiper-slide')?.length || 0;
  const lengthClass = itemLength > 2 ? 'item-over' : 'item-under';
  const spOnly = el?.dataset?.swiper;
  // 要素が存在しない場合は早期リターン
  if (!el) return;
  el.classList.add(lengthClass);
  // スマホのみの場合は早期リターン
  if(spOnly && !isMobile) return;
  // 要素が存在する場合のみoptionsを設定
  const options = {
    modules: [Autoplay,Navigation, Pagination],
    loop: false,
    speed: 750,
    slidesPerView: 1.1,
    spaceBetween: 20,
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true,
    },
    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
    breakpoints: {
      920: {
        slidesPerView: 2.2,
      },
    },
    watchOverflow: true,
    observer: true,
    observeParents: true
  };
  
  return new Swiper(el.querySelector('.interview-swiper'), options);
};

export const crossTalkSwiper = () => {
  // interview-swiper要素を取得
  const el = document.querySelector(".js-cross-talk-swiper");

  // 要素が存在しない場合は早期リターン
  if (!el) return;
  // 要素が存在する場合のみoptionsを設定
  const spSlidesPerView = el.dataset.spSlidesPerView ? el.dataset.spSlidesPerView : 1.1;
  const pcSlidesPerView = el.dataset.pcSlidesPerView ? el.dataset.pcSlidesPerView : 1.2;
  const itemLength = el?.querySelectorAll('.cross-talk-swiper .swiper-slide')?.length || 0;
  const lengthClass = itemLength > 2 ? 'item-over' : 'item-under';
  el.classList.add(lengthClass);
  const autoplay = {
    delay: 5000,
    disableOnInteraction: false,
  };
  const options = {
    modules: [Autoplay,Navigation, Pagination],
    loop: false,
    speed: 750,
    slidesPerView: spSlidesPerView,
    spaceBetween: 20,
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true,
    },

    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
    breakpoints: {
      920: {
        slidesPerView: pcSlidesPerView,
      },
    },
  };
  return new Swiper(el.querySelector('.cross-talk-swiper'), options);
};



export const newsSwiper = () => {
  const el = document.querySelector(".js-news-swiper-sp");
  if(!isMobile || !isUserAgentMobile || !el) return;
  const options = {
    modules: [Autoplay],
    loop: true,
    speed: 750,
    slidesPerView: 1.2,
    centeredSlides: true,
    spaceBetween: 20,
    initSlide: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  };
  return new Swiper(el, options);
};


export const mobileSwiper = () => {
  const el = document.querySelector(".js-mobile-swiper");
  const listCount = el?.querySelectorAll('.swiper-slide')?.length || 0;
  if(!isMobile || !el) return;
  console.log(listCount);
  const options = {
    modules: [Autoplay],
    loop: true,
    speed: 750,
    slidesPerView: 1.2,
    centeredSlides: true,
    spaceBetween: 20,
    initSlide: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  };
  return new Swiper(el, options);
};